import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  DatePicker,
  InputNumber,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS, dateFormat } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import { sortDataByOrder } from "../../../../utils/helper"
import moment from "moment";
import ReactPlayer from "react-player/youtube";
import SynthesiaVideo from "./SynthesiaVideo";
import userServiceApi from "../../../../api/userServiceApi";
import reArrangeOrder from "../../../common/DragAndDropList/rearrangeHelper";
import {
  DragAndDropList,
  GifCreator,
  GifResultPreview,
  createEmptyGifState,
  hydrateGifCreatorState,
} from "../../../common";

const { TextArea } = Input;
const MAX_CHARACTERS = 700;

const withGifDefaults = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (row?.mediaLink?.mediaType === "GIF") {
      return {
        ...row,
        mediaLink: {
          ...row.mediaLink,
          gifCreator: hydrateGifCreatorState(row.mediaLink),
        },
      };
    }
    return row;
  });
};

export default function ApprenticesComponent({ dataLoader, form }) {
  const { state } = useLocation();
  const { micrositeId } = useParams();

  const tabKey = state;
  const { tabData, skills } = useStore();
  const whichTab = TAB_KEYS.apprenticeship;
  const tabConfigId = localStorage?.getItem("selectedTabId");
  const { deleteSingleItem, postLoader, getSkills } = useTab();
  const [loader, setLoader] = useState(true);
  const { updateImage } = useConnectsuForm();
  const [skillOptions, SetSkillOptions] = useState([]);

  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();

  // 🔹 new states
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  // ✅ Empty apprenticeship row template
  const emptyRow = {
    id: undefined,
    title: "",
    compensation: null,
    closingDate: null,
    description: "",
    skillIds: [],
    urlLink: "",
    mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
    media: null,
  };

  useEffect(() => {
    localStorage.setItem("tab", "APPRENTICESHIP");
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);

  const renderMedia = (dataItem, rowIndex) => {
    const commonStyles = {
      // width: "350px",
      // height: "250px",
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <iframe
            title="Embedded video"
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <img
            src={dataItem?.mediaLink?.url}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "GIF"
    ) {
      const gifState = dataItem.mediaLink.gifCreator || {};
      const gifUrl = gifState.previewUrl || dataItem.mediaLink.url;
      return (
        <GifResultPreview
          url={gifUrl}
          fileName={gifState.fileName}
          loading={!!gifState.generating}
          showEdit={!!gifUrl && gifState.isEditing === false}
          onEdit={() => {
            const current = form.getFieldValue([
              whichTab,
              rowIndex,
              "mediaLink",
              "gifCreator",
            ]);
            form.setFieldValue(
              [whichTab, rowIndex, "mediaLink", "gifCreator"],
              { ...createEmptyGifState(), ...current, isEditing: true }
            );
          }}
        />
      );
    }
    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }
    return null;
  };

  useEffect(() => {
    getSkills();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };

  useEffect(() => {
    let tempSkillOptions = []
    if (skills && skills?.length > 0) {
      skills.forEach((skill) => {
        tempSkillOptions.push({ label: skill.name, value: skill.id })
      })
    }
    SetSkillOptions(tempSkillOptions)
  }, [skills])


  const getInitialSkills = (data) => {
    if (data && data.skills) {
      const values = [];
      data.skills.forEach((res) => {
        values.push(res.id);
      });
      return values;
    } else {
      return [];
    }
  };
  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
    if (e === "GIF") {
      form.setFieldValue(
        [whichTab, i, "mediaLink", "gifCreator"],
        createEmptyGifState()
      );
    } else {
      form.setFieldValue([whichTab, i, "mediaLink", "gifCreator"], undefined);
    }
  };


  // ✅ Handle Add More
  const handleAddMore = () => {
    if (!canAddNew) {
      toast.warning("You must save or clear the current item before adding a new one.")
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];
    const newList = [emptyRow, ...currentList];
    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Handle Clear
  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const updatedList = currentList.map(item => (!item?.id ? { ...emptyRow } : item));
    form.setFieldsValue({ [whichTab]: updatedList });

    // refreshUnsavedState();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.PART_TIME?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.PART_TIME]);

  // ✅ Refresh Unsaved State
  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.urlLink?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.media ||
        item?.compensation ||
        (item?.skillIds && item?.skillIds.length > 0) ||
        item?.mediaLink?.gifCreator?.images?.length ||
        item?.mediaLink?.gifCreator?.generatedFile;
      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  // ✅ Track unsaved row on form change
  useEffect(() => {
    const unsubscribe = form.subscribe?.(() => refreshUnsavedState());
    return () => unsubscribe?.();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    form.resetFields();
    if (tabData && tabData[whichTab] && tabData[whichTab].length > 0) {
      form.setFieldsValue({
        [whichTab]: withGifDefaults(sortDataByOrder(tabData[whichTab])),
      });
    }
    refreshUnsavedState();
    setTimeout(() => setLoader(false), 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData[whichTab]]);

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="newContantStyle">
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <>
                  <Form.List
                    name={whichTab}
                    initialValue={
                      tabData &&
                        tabData[whichTab] &&
                        tabData[whichTab].length > 0
                        ? withGifDefaults(sortDataByOrder(tabData[whichTab]))
                        : [""]
                    }
                  >
                    {(fields, { add, remove, move }) => {
                      return (
                        <>
                          <Col
                            className="gutter-row tabContent"
                            xs={24}
                            sm={24}
                            md={14}
                            lg={14}
                            style={{ paddingRight: "25px" }}
                          >
                            <div className="inputBody">
                              <label></label>
                              <div style={{ textAlign: "right" }}>
                                {hasUnsavedItem && (
                                  <Button
                                    className="cancelBtn"
                                    type="button"
                                    onClick={handleClear}
                                  >
                                    Clear
                                  </Button>
                                )}
                                <Button
                                  className="greenBtn"
                                  onClick={handleAddMore}
                                >
                                  Add <PlusOutlined />
                                </Button>
                              </div>
                            </div>
                          </Col>

                          <Col
                            className="gutter-row tabContent"
                            xs={24}
                            sm={24}
                            md={10}
                            lg={10}
                          >
                          </Col>

                          <DragAndDropList
                            fields={fields}
                            move={move}
                            form={form}
                            fieldName={whichTab}
                            onReorder={(payload) => reArrangeOrder(userServiceApi.reArrangeCardsInApprenticeshipsAndVacancy({ micrositeId, tabConfigId }), payload)}
                            renderItem={({ key, name, ...restField }, i) => (
                              <div className="card-item">
                              <Col
                                className="gutter-row tabContent"
                                xs={24}
                                sm={24}
                                md={14}
                                lg={14}
                                style={{ paddingRight: "25px" }}
                              >
                                <div className="d-flex">
                                  <Form.Item
                                    label="Apprenticeship Title"
                                    {...restField}
                                    className="w-100"
                                    name={[name, "title"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Apprenticeship Title is required",
                                      },
                                    ]}
                                    labelCol={{ span: 6 }}
                                  >
                                    <Input
                                      placeholder="Apprenticeship Title"
                                      maxLength={40}
                                      showCount={{
                                        formatter: ({ count }) => `${count}/40`,
                                      }}

                                      onKeyDown={(e) => {
                                        const currentValue =
                                          form.getFieldValue([whichTab, name, "title"]) || "";

                                        if (
                                          e.key.length === 1 && // normal characters only
                                          currentValue.length >= 40
                                        ) {
                                          form.setFields([
                                            {
                                              name: [whichTab, name, "title"],
                                              errors: ["Title cannot exceed 40 characters"],
                                            },
                                          ]);
                                        }
                                      }}
                                      onBlur={() => {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "title"],
                                            errors: [],
                                          },
                                        ]);
                                      }}
                                    />
                                  </Form.Item>

                                  <Form.Item>
                                    <div className="remove-btn">
                                      <DeleteOutlined
                                        title="Delete News"
                                        onClick={() => {
                                          const id = form.getFieldValue([
                                            whichTab,
                                            i,
                                            "id",
                                          ]);
                                          if (id) {
                                            // Existing saved record → call delete API
                                            deleteSingleItem(
                                              whichTab,
                                              id,
                                              form
                                            );
                                          } else {
                                            // Newly added unsaved record → just remove from form list
                                            setHasUnsavedItem(false);
                                            remove(name);
                                            refreshUnsavedState();
                                          }
                                        }}
                                      />
                                    </div>
                                  </Form.Item>
                                </div>
                                <Form.Item
                                  {...restField}
                                  label="Annual salary"
                                  name={[name, "compensation"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Annual salary is required",
                                      type: "regexp",
                                      pattern: new RegExp(/\d+/g),
                                    },
                                  ]}
                                  labelCol={{ span: 6 }}
                                >
                                  <InputNumber
                                    style={{ width: "100%" }}
                                    placeholder="Annual salary"
                                    min={0}
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  label="Closing Date"
                                  name={[name, "closingDate"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Closing Date is required",
                                    },
                                  ]}
                                  labelCol={{ span: 6 }}
                                >
                                  <DatePicker
                                    format={dateFormat}
                                    disabledDate={(current) => {
                                      return (
                                        current &&
                                        current < moment().startOf("day")
                                      );
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="Description"
                                  {...restField}
                                  labelCol={{ span: 6 }}
                                  name={[name, "description"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Description is required",
                                    },
                                    {
                                      max: MAX_CHARACTERS - 1,
                                      message: `Description should be less than ${MAX_CHARACTERS} character`,
                                    },
                                  ]}
                                >
                                  <TextArea
                                    placeholder="Enter Description"
                                    rows={5}
                                    maxLength={MAX_CHARACTERS}
                                    showCount
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="Skills"
                                  valuePropName="value"
                                  initialValue={getInitialSkills(
                                    tabData &&
                                      tabData[whichTab] &&
                                      tabData[whichTab].length > 0
                                      ? tabData[whichTab][i]
                                      : [""]
                                  )}
                                  {...restField}
                                  name={[name, "skillIds"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Skills are required",
                                    },
                                  ]}
                                  labelCol={{ span: 6 }}
                                >
                                  <Select
                                    mode="multiple"
                                    allowClear
                                    filterOption={(inputValue, option) => {
                                      return option.label
                                        ?.toLowerCase()
                                        .includes(inputValue.toLowerCase());
                                    }}
                                    placeholder="Please select"
                                    options={skillOptions}
                                  />
                                </Form.Item>
                                <div className="d-flex">
                                  <Form.Item
                                    label="Apprenticeship Link"
                                    {...restField}
                                    className="w-100"
                                    name={[name, "urlLink"]}
                                    labelCol={{ span: 6 }}
                                  >
                                    <Input
                                      placeholder="Apprenticeship Link"
                                      name={[name, "urlLink"]}
                                    />
                                  </Form.Item>
                                  <Form.Item>
                                    <div className="remove-btn">
                                      <Tooltip
                                        title={"Enter the complete link"}
                                      >
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                  </Form.Item>
                                </div>
                                <div className="d-flex">
                                  <Form.Item
                                    {...restField}
                                    className="w-100"
                                    name={[name, "mediaLink", "mediaType"]}
                                    label=" Video or Image"
                                    labelCol={{ span: 6 }}
                                  >
                                    <Select
                                      name={[name, "mediaLink", "mediaType"]}
                                      onChange={(e) =>
                                        SelectChangeHandler(e, i)
                                      }
                                      placeholder="Select Option"
                                      allowClear
                                    >
                                      <Select.Option value="VIMEO_MEDIA">
                                        Add Vimeo Link
                                      </Select.Option>
                                      <Select.Option value="SOCIAL_MEDIA">
                                        Add Youtube Link
                                      </Select.Option>
                                      <Select.Option value="SYNTHESIA_MEDIA">
                                        Add Synthesia Link
                                      </Select.Option>
                                      <Select.Option value="IMAGE">
                                        Upload Image
                                      </Select.Option>
                                      <Select.Option value="GIF">
                                        Create GIF
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                  <Form.Item>
                                    <div className="remove-btn">
                                      <Tooltip
                                        title={
                                          "Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio"
                                        }
                                      >
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                  </Form.Item>
                                </div>
                                {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                  <Form.Item
                                    label="Youtube Link"
                                    labelCol={{ span: 6 }}
                                    {...restField}
                                    name={[name, "mediaLink", "url"]}
                                  >
                                    <Input />
                                  </Form.Item>
                                ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                  <Form.Item
                                    label="Vimeo Link"
                                    labelCol={{ span: 6 }}
                                    {...restField}
                                    name={[name, "mediaLink", "url"]}
                                  >
                                    <Input />
                                  </Form.Item>
                                ) : findValue(i, "type") === "IMAGE" ? (
                                  <Form.Item
                                    {...restField}
                                    label="Image"
                                    colon={false}
                                    name="media"
                                    className="experienceImg"
                                    labelCol={{ span: 6 }}
                                  >
                                    {findValue(i, "blob") ? (
                                      <Avatar
                                        src={URL.createObjectURL(
                                          findValue(i, "blob")
                                        )}
                                        alt=""
                                      />
                                    ) : findValue(i, "url") ? (
                                      <Avatar
                                        src={findValue(i, "url")}
                                        alt=""
                                      />
                                    ) : (
                                      <Avatar src={UserIcon} />
                                    )}

                                    <label
                                      name="file"
                                      className="fileUploadBtn greenBtn"
                                    >
                                      {" "}
                                      Upload Image
                                      <input
                                        accept="image/png, image/gif, image/jpeg"
                                        type="file"
                                        // required={true}
                                        onChange={(e) =>
                                          updateImage(e, i, form, whichTab)
                                        }
                                      />
                                    </label>
                                    <Tooltip
                                      className="question"
                                      title={"Recommended image dimensions: 1280x720 pixels"}
                                    >
                                      <QuestionCircleOutlined />
                                    </Tooltip>
                                  </Form.Item>
                                ) : findValue(i, "type") === "GIF" ? (
                                  <Form.Item
                                    {...restField}
                                    label="Create GIF"
                                    colon={false}
                                    name={[name, "mediaLink", "gifCreator"]}
                                    className="gif-creator-field"
                                    labelCol={{ span: 6 }}
                                    initialValue={createEmptyGifState()}
                                  >
                                    <GifCreator />
                                  </Form.Item>
                                ) : findValue(i, "type") ===
                                  "SYNTHESIA_MEDIA" ? (
                                  <Form.Item
                                    label="Synthesia Link"
                                    labelCol={{ span: 6 }}
                                    {...restField}
                                    name={[name, "mediaLink", "url"]}

                                  >
                                    <Input />
                                  </Form.Item>
                                ) : null}
                                <Form.Item
                                  className="w-100"
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  {formChanged ? (
                                    <Button
                                      className="saveBtn greenBtn"
                                      onClick={() => {
                                        form.submit();
                                      }}
                                    >
                                      Save
                                    </Button>
                                  ) : (
                                    <Button
                                      className="saveBtn greenBtn"
                                      style={{
                                        opacity: "0.5",
                                        pointerEvents: "none",
                                      }}
                                    >
                                      Save
                                    </Button>
                                  )}
                                </Form.Item>
                              </Col>
                              <Col
                                className="gutter-row tabContent"
                                xs={24}
                                sm={24}
                                md={10}
                                lg={10}
                              >
                                <Form.Item shouldUpdate noStyle>
                                  {() => {
                                    const row = form.getFieldValue(whichTab)?.[i];
                                    if (!row) return null;
                                    return (
                                      <div>
                                        {renderMedia(row, i)}
                                      </div>
                                    );
                                  }}
                                </Form.Item>
                          </Col>
                        </div>
                    )}
                  />
                    </>
                  );
                    }}
                  </Form.List>
                </>
              </Col>


            </>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
